import { Outlet, Navigate } from "react-router-dom";
import { Suspense } from "react";

export function RedirectToAllInvoices() {
  return <Navigate to="../all-invoices" replace />;
}

function AllPayments() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-10">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
}

export default AllPayments;
